import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { useLanguage } from "@/i18n/LanguageContext";
import { PRIVACY_POLICY } from "@/legal/privacyPolicy";
import { TERMS_CONDITIONS } from "@/legal/termsConditions";

const Block = ({ block }) => {
  if (block.type === "h2") {
    return (
      <h2 className="pt-10 font-display text-xl font-bold uppercase tracking-tight text-white sm:text-2xl">
        {block.text}
      </h2>
    );
  }
  if (block.type === "h3") {
    return <h3 className="pt-6 text-base font-bold text-white sm:text-lg">{block.text}</h3>;
  }
  if (block.type === "list") {
    return (
      <ul className="space-y-2.5">
        {block.items.map((item, i) => (
          <li key={i} className="flex gap-3 leading-relaxed">
            <span className="mt-[0.6em] h-1.5 w-1.5 shrink-0 rounded-full bg-brand" />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    );
  }
  return <p className="leading-relaxed">{block.text}</p>;
};

const LegalPage = ({ kind }) => {
  const { t } = useLanguage();
  const doc = kind === "privacy" ? PRIVACY_POLICY : TERMS_CONDITIONS;

  return (
    <div data-testid={`legal-${kind}-page`} className="min-h-screen bg-pitch">
      <header className="border-b border-brand/10 bg-pitch/80 backdrop-blur-xl">
        <div className="mx-auto flex h-[72px] max-w-3xl items-center px-5 sm:px-8">
          <Link to="/" data-testid="legal-logo-home" aria-label="TeamUp home">
            <Logo />
          </Link>
        </div>
      </header>
      <motion.main
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="mx-auto max-w-3xl px-5 py-16 sm:px-8 md:py-24"
      >
        <Link
          to="/"
          data-testid="legal-back-link"
          className="mb-10 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-white/50 transition-colors duration-300 hover:text-brand"
        >
          <ArrowLeft className="h-4 w-4" />
          {t.legal.back}
        </Link>
        <h1 className="font-display text-3xl font-extrabold uppercase tracking-tight text-white sm:text-5xl">{doc.title}</h1>
        <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.2em] text-brand/80">{doc.updated}</p>

        <div data-testid={`legal-${kind}-content`} className="mt-10 space-y-5 text-base text-mist">
          {doc.blocks.map((block, i) => (
            <Block key={i} block={block} />
          ))}
        </div>

        <div className="mt-16 border-t border-white/[0.07] pt-8">
          <Link to="/" data-testid="legal-footer-home-link" className="font-mono text-xs uppercase tracking-[0.2em] text-brand/80 transition-colors duration-300 hover:text-brand">
            teamup-app.fr
          </Link>
        </div>
      </motion.main>
    </div>
  );
};

export default LegalPage;
